import DrawAngleAnim from "../../../../../../src/animation/Intro/DrawAngleAnim";
import DrawCircleAnim from "../../../../../../src/animation/Intro/DrawCirleAnimation";
import DrawLineAnim from "../../../../../../src/animation/Intro/DrawLineAnimation";
import DrawPointAnim from "../../../../../../src/animation/Intro/DrawPointAnimation";
import AngularOscillationAnimation from "../../../animations/AngularOscillationAnimation";
import RotateCircleAnim from "../../../../../../src/animation/Intro/RotateCircleAnim";

import SwapSprite from "../../../../../../src/animation/SwapSprite";
import MovePointAnimation from "../../../../../../src/animation/Intro/MovePointAnim";


export function drawPointsAnim(pointsArr: []): Promise<void> {
  return new Promise((resolve) => {
    pointsArr.forEach((point: any) => {
      point.visible = true;
      point.scale = 0.2;
      new DrawPointAnim(point, () => resolve());
    })
  })
}

export function drawAngleAnim(angle, value: string): Promise<void> {
  return new Promise((resolve) => {
    angle.visible = true;
    angle.scale.set(0.3);
    new DrawAngleAnim(angle, () => {
      angle.AngleValue.setValue(value);
      angle.AngleValue.visible = true;
      resolve();
    });
  });
}

export function drawLineAnim(line, from, to): Promise<void> {
  return new Promise((resolve) => {
    new DrawLineAnim(line, from, to, resolve);
  });
}

export function drawCircleAnim(circle, radian, isClockwise, coord): Promise<void> {
  return new Promise((resolve) => {
    new DrawCircleAnim(circle, radian, 0, isClockwise, coord, () => resolve());
  });
}

export function drawAnglrOscilAnim(startRadian, callback): Promise<void> {
  return new Promise((resolve) => {
    new AngularOscillationAnimation(startRadian, callback, () => resolve());
  })
}

export function movePointAnim(sAngle, tAngle, callback, onComp = () => { }): Promise<void> {
  return new Promise((resolve) => {
    new MovePointAnimation(sAngle, tAngle, callback, () => setTimeout(() => {
      resolve();
      onComp();
    }, 600))
  })
}

export function moveAllPointAnim(sAngleArr: number[], tAngleArr: number[], callback: (angle: number, index: number) => void): Promise<void> {
  return new Promise((resolve) => {
    tAngleArr.forEach(async (tAngle, tAIndex) => {
      if (tAIndex < tAngleArr.length - 1) {
        return movePointAnim(sAngleArr[tAIndex], tAngle, (angle) => callback(angle, tAIndex));
      }
      await movePointAnim(sAngleArr[tAIndex], tAngle, (angle) => callback(angle, tAIndex), () => resolve());
    })
  })
}

export function showCalcLine(calcLine): Promise<void> {
  return new Promise(() => new SwapSprite(calcLine, .4, 1))
}
export function showSuppleAngleLine(supplAngleLine): Promise<void> {
  return new Promise(() => new SwapSprite(supplAngleLine, .4, 1))
}

export function showSlidersAnim(SliderManager): Promise<void> {
  return new Promise(() => {
    SliderManager.setAllVisible(true);
    const sliders = SliderManager.getSliders();
    sliders.forEach(slider => new SwapSprite(slider, .3, 1))
  })
}

export function rotateCircleAnim(callback): Promise<void> {
  return new Promise((resolve) => new RotateCircleAnim(callback, 2, resolve));
}
